@use "../../../globals/settings";
@use "../../../globals/bcp-2022/common/supergraphic";
@use "../../../globals/bcp";
@use "../../../globals/libs/hy.core.css/layout/page-row";

$self: ".o-header";

:host {
  display: block;
}

.l-page-row {
  @include page-row.page-row;
}

.o-header {
  @include supergraphic.generate();

  &__top {
    display: flex;
    align-items: center;
    min-height: 96px;
    padding-top: bcp.n(2);
    padding-bottom: bcp.n(2);
    box-sizing: border-box;

    @include bcp.respond-lte(tabletp) {
      padding-top: 0;
      padding-bottom: 0;
      min-height: 48px;
    }
  }

  &__logo-container {
    ::slotted(f-logo) {
      width: 144px;

      @include bcp.respond-lte(tabletp) {
        width: 108px;
      }
    }
  }

  &__quicklinks-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__search-container {
    display: flex;
    align-items: center;
  }

  &__mid {
    display: flex;
    align-items: center;
  }

  &__navigation-container {
    flex-grow: 1;
  }

  &__subbrand {
    margin: 0;
    font-weight: bcp.$font-weight-bold;
  }

  &__bottom {
    display: flex;
    align-items: center;
  }

  &__breadcrumbs-container {
    flex-grow: 1;
    padding-top: bcp.n(2, settings.$rel-unit);
    padding-bottom: bcp.n(2, settings.$rel-unit);

    @include bcp.respond-lte(tabletp) {
      display: none;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
